import type { ReactNode } from "react";

export interface LoadingButtonProps {
	onClick: () => void;
	disabled?: boolean;
	loading?: boolean;
	variant?: "primary" | "secondary";
	className?: string;
	children: ReactNode;
}

export function LoadingButton({
	onClick,
	disabled = false,
	loading = false,
	variant = "primary",
	className,
	children,
}: LoadingButtonProps) {
	const isDisabled = disabled || loading;
	const variantClass = variant === "primary" ? "btn-primary" : "btn-ghost";
	const classes = className ? `btn ${variantClass} loading-button ${className}` : `btn ${variantClass} loading-button`;

	return (
		<button
			type="button"
			className={classes}
			onClick={onClick}
			disabled={isDisabled}
		>
			{loading ? (
				<>
					<span className="loading-button__spinner" />
					<span>Loading...</span>
				</>
			) : (
				children
			)}
		</button>
	);
}
